import {createFileRoute} from '@tanstack/react-router';

import {
  categoryKeys,
  categoryPresetKeys,
} from '@/features/Library/api/queryKeys';
import {getCategories} from '@/features/Library/api/readCategories';
import {getCategoryPreset} from '@/features/Library/api/readCategoryPreset';
import {CategoryPresetModal} from '@/features/Library/components/CategoryPreset/CategoryPresetModal';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/categories/preset/$presetId'
)({
  component: CategoryPresetModal,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.presetId);

    return {
      ...context,
      readCategoryPresetQuery: {
        queryKey: categoryPresetKeys.detail(params.presetId),
        queryFn: () => getCategoryPreset(params.presetId),
      },
      readCategoriesQuery: {
        queryKey: categoryKeys.list({presetId: params.presetId}),
        queryFn: () => getCategories({presetId: params.presetId}),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readCategoryPresetQuery),
      context.queryClient.ensureQueryData(context.readCategoryPresetQuery),
    ]);
  },
});
